import { captureException } from '@common/sentry';
import { HTTPErrorTags, SentryTags } from '@common/sentry/SentryTags';
import { isPublicURL, isAuthRoute } from '@common/url';
import { toast } from '@prophecy/ui/Toast';
import { ProphecyError } from '@prophecy/utils/error';
import { clearStorage } from '@prophecy/utils/history';

import { csrf } from '../../utils/csrf';
import { SHOW_JPMC_POST_LOGIN_COPILOT_POPUP_ACKNOWLEDGED } from '../../utils/localstorage-keys';
import { replayToken } from '../../utils/replayToken';
import { shareToken } from '../../utils/shareToken';
import { AppLogLevel, appLogger } from '../apis/appLogger';
import { fetchURL } from './fetchUrl';
import { redirectToAuth } from './redirectToAuth';
import { isReplayUrl, isShareUrl } from './util';

export const handleUnAuthorizedCall = (status: number, url: string) => {
  const path = window.location.pathname;
  let isAuthorized = true;
  if (!isShareUrl() && !isReplayUrl() && status === 401 && !isAuthRoute(path) && !isPublicURL(path)) {
    appLogger({
      entity: 'User',
      operation: '401 Redirect',
      log: `Previous API call: ${url}
        Current Path: ${path}`,
      logLevel: AppLogLevel.error
    });
    csrf.delete();
    shareToken.delete();
    replayToken.delete();
    toast.error({ content: `Login Expired` });
    clearStorage();
    localStorage.removeItem(SHOW_JPMC_POST_LOGIN_COPILOT_POPUP_ACKNOWLEDGED);
    redirectToAuth();
    captureException({
      exception: new ProphecyError(`Login Expired`),
      errorTags: { [SentryTags.ProphecyErrorHttpType]: HTTPErrorTags.SessionExpire }
    });
    isAuthorized = false;
  }
  return isAuthorized;
};

export function authorizedFetch(url: URL | RequestInfo, requestConfig: RequestInit | undefined) {
  return fetchURL(url, requestConfig, handleUnAuthorizedCall);
}

export function authorizedFetchWithoutShareTokens(url: URL | RequestInfo, requestConfig?: RequestInit) {
  return fetchURL(url, requestConfig, handleUnAuthorizedCall, true);
}
